import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './TutorialVideo.css';
import tutorialVideo from '../assete/tutorial Vedio.mp4';

interface TutorialVideoProps {
  showByDefault?: boolean;
  buttonText?: string;
  onClose?: () => void;
}

export const TutorialVideo: React.FC<TutorialVideoProps> = ({ 
  showByDefault = false,
  buttonText = "📺 Watch Tutorial",
  onClose
}) => {
  const [isOpen, setIsOpen] = useState(showByDefault);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  if (!isOpen) {
    return (
      <button onClick={handleOpen} className="tutorial-button">
        {buttonText}
      </button>
    );
  }

  const modalContent = (
    <div className="tutorial-modal-overlay" onClick={handleClose}>
      <div className="tutorial-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-modal-header">
          <h2>📺 Tutorial Video</h2>
          <button onClick={handleClose} className="tutorial-close-btn">
            ✕
          </button>
        </div>
        <div className="tutorial-video-container">
          <video 
            controls 
            autoPlay
            className="tutorial-video"
            poster=""
          >
            <source src={tutorialVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="tutorial-modal-footer">
          <p>Learn how to use the cognitive training games effectively</p>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default TutorialVideo;
